import Vue from 'vue'

/**
 * 获取URL上查询参数
 * @returns {object}
 */
export function getURLParam () {
  const search = location.search
  return Object.fromEntries(new URLSearchParams(search))
}

/**
 * 把url、object拼接成查询参数URL
 * @Desc convert JSON !isRest  {a:b,x:y} into ?a=b&x=y else into /b/y
 * @Params param--> 需要被传入的JSON参数, url=> url地址
 * @Parama isRest--> url地址是否由restful的形式拼接
 * @returns {String}
 */
export function addUrlParams (url, param, isRest) {
  // eslint-disable-next-line no-extend-native
  !String.formated && (String.prototype.formated = function () {
    const jsonFlag = arguments.length === 1 && arguments[0] instanceof Object
    const args = jsonFlag ? arguments[0] : arguments
    const reg = jsonFlag ? /\{(\w+)\}/g : /\{(\d+)\}/g

    return this.replace(reg,
      function (m, i) {
        return args[i] || ''
      })
  })
  // const p = param || {}
  const noP = url.indexOf('?') === -1
  const tpl = '&{0}={1}'
  let params = ''
  for (const k in param) {
    const v = param[k]
    params += !isRest ? tpl.formated(k, v) : `/${v}`.formated(param)
  }
  !isRest && noP && (params = params.replace('&', '?'))
  return url + params
}

/**
 * 返回认证地址URL
 * @returns {*}
 */
export function authAddUrl () {
  return addUrlParams(Vue.prototype.$APP_CONFIG.AUTH_URL,
    {
      client_id: '13ecd50e-c385-11e7-9100-fa163ed3019d',
      response_type: 'code',
      redirect_uri: '',
    })
}
/**
 * 返回我的主页地址
 * @returns {*}
 */
export function learnWLURL () {
  let url=Vue.prototype.$APP_CONFIG.LEARNING_WLURL ;
  return url;
}
/**
 * 返回学习中心公共地址
 * @returns {*}
 */
export function learnUrl () {
  let url=Vue.prototype.$APP_CONFIG.LEARNING_URL ;
  return url;
}

/**
 * 返回首页URL
 * @returns {*}
 */
export function jumpHome () {
  return authAddUrl() + window.encodeURIComponent(window.location.origin+window.location.pathname);
  // return window.location.protocol + '//' + window.location.host + process.env.BASE_URL
}

/**
 * 格式化日期
 * @returns {*}
 */
export function formatDate (date = new Date(), all = false) {
  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(date)
  }
  const array = ['getFullYear', 'getMonth', 'getDate']
  const _date = []
  for (const i of array) {
    let _i = date[i]()
    i === 'getMonth' && _i++
    _i < 10 && (_i = `0${_i}`)
    _date.push(_i)
  }
  const year = _date.join('-')
  return all ? {
    year,
    month: `${_date[0]}-${_date[1]}`,
    day: `${_date[1]}-${_date[2]}`,
    $year: _date[0],
    $month: _date[1],
    $day: `${Number(_date[2])}`,
    $week: `${date.getDay()}`,
    $time: date.getTime(),
  } : year
}

/**
 * 格式化日期
 * @param {string, Date} date 日期，如：2012-12-12 12:12:12
 * @param {string} fmt 格式，如：yyyy-MM-dd HH:mm:ss 或者 yyyy年MM月dd日 HH时mm分ss秒 或者 yyyy/MM/dd HH:mm:ss
 * @return {string} 日期
 */
export function formatDateFMT (date, fmt) {
  if (!date) {
    return ''
  }
  if (!(date instanceof Date)) {
    if (/-/.test(date)) {
      date = date.replace(new RegExp(/-/gm), '/') // 浏览器兼容性处理
    }
    date = new Date(date)
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

/**
 * 补零
 * @param {string} str
 * @return {string}
 */
function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

/**
 * 一天毫秒数
 * @returns {*}
 */
export const MILLISECOND = 1000 * 60 * 60 * 24

/**
 * 返回对象（now：当前日期对象，list：日期集合，一个月，补满每周日期）
 * @returns {*}
 */
export function setDateList (date = new Date()) {
  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(date)
  }
  const array = []
  const time = formatDate(date, true)
  const day = date.getDate()
  const daySum = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  // 获取选中日期前的天数（一月）
  if (day > 1) {
    for (let i = day - 1; i > 0; i--) {
      array.push(formatDate(date.getTime() - (MILLISECOND * i), true))
    }
  }
  array.push(time)
  // 获取选中日期后的天数（一月）
  if (day < daySum) {
    for (let i = 0, length = daySum - day; i < length; i++) {
      array.push(formatDate(date.getTime() + (MILLISECOND * (i + 1)), true))
    }
  }
  const beforeArray = []
  const afterArray = []
  const beforeDate = new Date(array[0].year)
  const afterDate = new Date(array[array.length - 1].year)
  const beforeWeek = beforeDate.getDay()
  const afterWeek = afterDate.getDay()
  // 补足当前月份缺少的天数（上月）
  if (beforeWeek > 0) {
    for (let i = beforeWeek; i > 0; i--) {
      beforeArray.push(formatDate(beforeDate.getTime() - (MILLISECOND * i), true))
    }
  }
  // 补足当前月份缺少的天数（下月）
  if (afterWeek < 6) {
    for (let i = 0, length = 6 - afterWeek; i < length; i++) {
      afterArray.push(formatDate(afterDate.getTime() + (MILLISECOND * (i + 1)), true))
    }
  }
  return {
    now: time,
    list: beforeArray.concat(array, afterArray),
    nowArray: array,
  }
}

/**
 * 日期格式化 YYYY-MM-DD
 * @param date
 * @returns {*}
 */
export function formatDateIndex (date = new Date(), all = false) {
  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(date)
  }
  const array = ['getFullYear', 'getMonth', 'getDate']
  const _date = []
  for (const i of array) {
    let _i = date[i]()
    i === 'getMonth' && _i++
    _i < 10 && (_i = `0${_i}`)
    _date.push(_i)
  }
  const year = _date.join('-')
  return all ? {
    year,
    month: `${_date[0]}-${_date[1]}`,
    day: `${_date[1]}-${_date[2]}`,
    $year: _date[0],
    $month: _date[1],
    $day: `${Number(_date[2])}`,
    $week: `${date.getDay()}`,
    $time: date.getTime(),
  } : year
}

/**
 *
 * @param arr
 * @returns {Buffer | * | *[] | string}
 */
export function addBlankItem (arr) {
  const len = arr.length
  const max = Math.ceil(len / 4)
  const schoolArray = []
  for (let i = 0; i < max * 4 - len; i++) {
    schoolArray.push({})
  }
  return arr.concat(schoolArray)
}

/**
 * @Desc 删除指定的数组下标
 * @param array 被检查的数据
 * @param item 对比的数组项
 * @param key 对比的候选键
 * @returns {*} 返回被删除数组
 */
export function removeCorrectArray (array, item, key) {
  array.forEach((it, idx) => {
    if (it[key] === item[key]) {
      array.splice(idx, 1)
    }
  })
  return array
}

export function setDateListIndex (date = new Date()) {
  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(date)
  }
  const array = []
  const time = formatDateIndex(date, true)
  const day = date.getDate()
  const daySum = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  // 获取选中日期前的天数（一月）
  if (day > 1) {
    for (let i = day - 1; i > 0; i--) {
      array.push(formatDateIndex(date.getTime() - (MILLISECOND * i), true))
    }
  }
  array.push(time)
  // 获取选中日期后的天数（一月）
  if (day < daySum) {
    for (let i = 0, length = daySum - day; i < length; i++) {
      array.push(formatDateIndex(date.getTime() + (MILLISECOND * (i + 1)), true))
    }
  }
  const beforeArray = []
  const afterArray = []
  const beforeDate = new Date(array[0].year)
  const afterDate = new Date(array[array.length - 1].year)
  const beforeWeek = beforeDate.getDay()
  const afterWeek = afterDate.getDay()
  // 补足当前月份缺少的天数（上月）
  if (beforeWeek > 0) {
    for (let i = beforeWeek; i > 0; i--) {
      beforeArray.push(formatDateIndex(beforeDate.getTime() - (MILLISECOND * i), true))
    }
  }
  // 补足当前月份缺少的天数（下月）
  if (afterWeek < 6) {
    for (let i = 0, length = 6 - afterWeek; i < length; i++) {
      afterArray.push(formatDateIndex(afterDate.getTime() + (MILLISECOND * (i + 1)), true))
    }
  }
  return {
    now: time,
    list: beforeArray.concat(array, afterArray),
  }
}

export function urlSplit (query) {
  const url = location.search // 获取url中"?"符后的字串
  // eslint-disable-next-line no-new-object
  const theRequest = new Object()
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

/**
 * 判断是h5还是web
 * @returns {boolean}
 */
export function getUserAgent () {
  const ua = navigator.userAgent
  const isWeb = ua.match(/Win/i) || ua.match(/Macintosh/i) || ua.match(/Macintosh; Intel/i)
  const isWeChat = ua.match(/MicroMessenger/i)
  const flag = isWeChat ? true : !isWeb
  return flag
}

/**
 *
 * @param url
 * @param json
 */
export function redirect (url, json, isOpen = true) {
  url ? (!isOpen ? (location.href = json ? addUrlParams(url, json) : url) : window.open(json ? addUrlParams(url, json) : url)) : location.reload()
}

export function getParentIframe (heights = 800) {
  const dataJson = JSON.stringify({
    height: heights ? (heights + 40) : document.body.scrollHeight + 289,
    url: window.location.href,
  })
  window.parent.postMessage(dataJson, '*')
}

/**
 * 判断url时否包含http(s)
 * @param url
 */
export function isHTTP (url) {
  const reg = /(http|https):\/\//
  return reg.test(url)
}

/**
 * 通过url下载文件
 * @param {string} url 文件路径
 */
export function downloadFile (url) {
  const iframe = document.createElement('iframe')
  iframe.src = url
  iframe.style.display = 'none'
  document.body.appendChild(iframe)
  setTimeout(function () {
    iframe.remove()
  }, 5000)
}

/**
 * 通过blob下载文件
 * @param blob
 * @param {string} fileName 文件名
 */
export function downloadBlobFile (blob, fileName) {
  /* eslint-disable no-undef */
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName)
  } else {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    link.click()
    window.URL.revokeObjectURL(link.href)
  }
}
